import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

export const ERROR_BOUNDARY_NAMES = {
    APP: 'ErrorBoundary',
    LAZY_ROUTE: 'LazyErrorBoundary',
};

const ERROR_BOUNDARY_TAG = 'error-boundary';
const RENDER_ERROR_SUBJECT = 'Render error caught';
const LOG_ORIGIN_NETWORK = 'network';

export const formatLogMessage = (tag, subject, fields = {}) => {
    const parts = [`[${tag}] ${subject}`];
    Object.entries(fields).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            parts.push(`${key}=${value}`);
        }
    });
    return parts.join(' | ');
};

export const reportBoundaryError = (error, errorInfo, context = {}) => {
    datadogLogs.logger.error(
        formatLogMessage(ERROR_BOUNDARY_TAG, RENDER_ERROR_SUBJECT, context),
        { ...context, componentStack: errorInfo?.componentStack },
        error,
    );
};

// Failed fetch/XHR calls are already visible in the API's own logs. Console-origin logs are
// kept as-is: the prod bundle strips every console.* call (Terser drop_console), and React 17
// emits its console.error before the boundary runs, so its duplicate cannot be tagged from here.
export const shouldSendLog = (log) => log.origin !== LOG_ORIGIN_NETWORK;

// Internal member id only: the logging standard forbids email/name in telemetry.
export const syncDatadogUser = (user) => {
    if (user?.id === undefined || user?.id === null) {
        datadogLogs.clearUser();
        datadogRum.clearUser();
        return;
    }
    const datadogUser = { id: String(user.id) };
    datadogLogs.setUser(datadogUser);
    datadogRum.setUser(datadogUser);
};
